/* Function to create ellipsis in middle of text */
const createMiddleEllipsis = (string: string): string => {
  if (string.length > 14) {
    return string.slice(0, 6) + '....' + string.slice(-4);
  } else {
    return string;
  }
};

export default createMiddleEllipsis;
